import DatacorLogoSpinner from '../../../../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import React from 'react';
import FormPartial from '../../../../../../components/form/formContainer/FormPartial';
import SubSection15_2Form from './subSections/subSection15_2/SubSection15_2Form';
import SdsRegulationsGrid from './subSections/subSection15_1/SdsRegulationsGrid';
import { SdsHeader } from '../../../../../../types/formulation';
import { ChildEditableGridProps } from '../../../../../grid/utils/editableGrid/ChildEditableGridProps';
import { SdsBlobSectionFormProps } from '../shared/blobs/hooks/SdsBlobSectionFormProps';
import TranslatableText from '../../../../../../components/i18n/TranslatableText';
import { SDSFormDefs } from '../../../../../../constants/i18n/translations/termDefinitions/formulation';

const SdsRegulatoryInformationForm = (
    props: ChildEditableGridProps<SdsHeader> &
        SdsBlobSectionFormProps<SdsHeader>
) => {
    const { isParentLoading } = props.parentData;

    return (
        <>
            {isParentLoading ? (
                <DatacorLogoSpinner />
            ) : (
                <>
                    <FormPartial
                        title={
                            (
                                <TranslatableText
                                    termSet={props.termSet}
                                    termKey={SDSFormDefs.Regulatory_Information}
                                />
                            ) as unknown as string
                        }>
                        <SdsRegulationsGrid {...props} />
                        <SubSection15_2Form {...props} />
                    </FormPartial>
                </>
            )}
        </>
    );
};

export default SdsRegulatoryInformationForm;
